<template>
  <div v-if="isLoading">
    <section-title>
      <template v-if="isMyTurn">
        Stocks you are going to purchase
      </template>
      <template v-else>
        Stocks <span class="bold">{{ player.name }}</span> is going to purchase
      </template>
    </section-title>

    <div class="shopping-cart">
      <div class="stocks-container">
        <div class="price-container">
          <div class="price_title">Your Money</div>
          <div class="price_amount">{{ yourMoney | formatCurrency }}</div>

          <template v-if="isMyTurn">
            <div class="price_title">Amount Due</div>
            <div class="price_amount">{{ totalPrice | formatCurrency }}</div>

            <div class="price_amount balance">{{ playerBalance | formatCurrency }}</div>
          </template>
        </div>

        <div
          v-for="(stock, index) in stocksToBePurchased"
          :key="index"
          class="stocks"
          @click="onClickStock(index)"
        >
          <stock-card :hotel-id="stock" large />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { formatCurrency } from "@/currency-filter";
import { NS_GAME_STATE } from "@/store/constants";
import StockCard from "@/components/StockCard";
import SectionTitle from "@/components/SectionTitle";

export default {
  name: 'PurchaseStocks',

  components: {
    SectionTitle,
    StockCard,
  },

  filters: {
    formatCurrency,
  },

  data() {
    return {
      error: '',
    }
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'stocksToBePurchased',
      'localPlayer',
      'localPlayerId',
      'totalPrice',
      'whosTurn',
      'players',
      'isMyTurn',
    ]),

    isLoading () {
      return this.player;
    },

    yourMoney() {
      return this.localPlayer.money;
    },

    playerBalance() {
      return this.localPlayer.money - this.totalPrice;
    },

    player() {
      return this.players[this.whosTurn];
    }
  },

  methods: {
    ...mapActions(NS_GAME_STATE, [
      'removeStockToBePurchased',
    ]),

    onClickStock(arrayIndex) {
      this.removeStockToBePurchased(arrayIndex);
    },
  }
}
</script>

<style scoped>
.shopping-cart {
  padding: 10px;
}

.stocks-container {
  display: flex;
  height: 130px;
}

.price-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-right: 10px;
}

.price_title {
  font-size: 14px;
  margin-top: 3px;
}

.balance {
  padding-top: 10px;
  border-top: 4px solid #d0d0d0;
  border-top-style: double;
}

.bold {
  font-weight: 600;
}

.price_amount {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 3px;
  margin-top: 3px;
}
</style>
